export const EXTERNAL_ROUTES = {
  HELP_CENTER: 'https://support.photobucket.com',
  CONTACT_US: 'https://zendesk.photobucket.com/login/?return_to=https%3A%2F%2Fsupport.photobucket.com%2Fhc%2Fen-us%2Frequests%2Fnew',
  FACEBOOK: 'https://www.facebook.com/photobucket',
  TWITTER: 'https://twitter.com/photobucket',
  INSTAGRAM: 'https://www.instagram.com/photobucket',
  PINTEREST: 'https://www.pinterest.com/photobucket/',
  PRINTSHOP_CANVAS_PRINTS:
    'https://www.printshoplab.com/products/canvas?utm_medium=pbhomepage&utm_source=pbfooterlink&utm_content=pslcanvaslink&utm_campaign=pslcanvaspage',
  PRINTSHOP_PRINTS:
    'https://www.printshoplab.com/products/photo-prints?utm_medium=pbhomepaget&utm_source=pbfooterlink&utm_content=pslprintslink&utm_campaign=pslprintpage',
  PRINTSHOP_PHOTO_BOOKS:
    'https://www.printshoplab.com/products/photo-books?utm_medium=pbhomepage&utm_source=pbfooterlink&utm_content=pslphotobookslink&utm_campaign=photobookspage',
  PRINTSHOP_CARDS:
    'https://www.printshoplab.com/products/photo-cards?utm_medium=pbhomepage&utm_source=pbfooterlink&utm_content=pslgreetingcardslink&utm_campaign=greetingcardpage',
  PRINTSHOP_GIFTS:
    'https://www.printshoplab.com/products/photo-gifts?utm_medium=pbhomepage&utm_source=pbfooterlink&utm_content=pslgiftslink&utm_campaign=giftspage'
}

export const INTERNAL_ROUTES = {}
